export const resetCatalogue = () => ({
  type: 'RESET_CATALOGUE',
});
